import styled from "styled-components";

export const StyledEditableText = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  flex-direction: row;

  @media print {
    button {
      display: none !important;
    }
  }
`;
